'use client';

import { Button } from '@terra/ui-design-system';
import { useTranslations } from 'next-intl';
import { Message01Icon } from '@terra/ui-icons';
import { useMainContentTabs } from '../../store/layoutStore';
import { EmptyState } from '../EmptyState';

export const WELCOME_TARGET_PICKER_DATA_ID = 'welcome-target-picker';

function focusWelcomeTargetPicker(): void {
  const input = document.querySelector<HTMLInputElement>(
    `[data-id="${WELCOME_TARGET_PICKER_DATA_ID}"] input`,
  );

  if (!input) {
    return;
  }

  input.focus();
  input.click();
}

export function CoPilotNoTargetState() {
  const tCopilot = useTranslations('chat.copilot');
  const { openTab, setActiveTab } = useMainContentTabs();
  const handleSelectTarget = () => {
    openTab({
      id: 'welcome',
      title: 'Welcome',
      type: 'welcome',
    });
    setActiveTab('welcome');
    focusWelcomeTargetPicker();
    window.setTimeout(focusWelcomeTargetPicker, 50);
  };

  return (
    <EmptyState
      icon={Message01Icon}
      title={tCopilot('noApplicationTitle')}
      description={tCopilot('noApplicationDescription')}
      action={
        <Button size="sm" variant="outline" onClick={handleSelectTarget}>
          {tCopilot('selectApplicationAction')}
        </Button>
      }
    />
  );
}
